import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69a672264fab3d0014dccd81/kratapillar/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a672264fab3d0014dccd81/kratapillar/src/app/shop/components/ShopInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a672264fab3d0014dccd81/kratapillar/src/components/Header.tsx");
